import { render, staticRenderFns } from "./ServiceForms.vue?vue&type=template&id=0e01effc"
import script from "./ServiceForms.vue?vue&type=script&lang=js"
export * from "./ServiceForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports